<template>
  <div class="vl-person-detail">
    <el-form :model="formInline" label-width="180px" style="width: 80%;margin: 30px auto 0;">
      <el-form-item label="应用名称：">
        <span>{{formInline.appName || ''}}</span>
      </el-form-item>
      <el-form-item label="应用logo：">
        <img width="180px" height="180px" :src="formInline.appLogo">
      </el-form-item>
      <el-form-item label="应用分类：">
        <span>{{formInline.appTypeName || ''}}</span>
      </el-form-item>
      <el-form-item label="适用对象：">
        <span>{{formInline.accountTypeName || ''}}</span>
      </el-form-item>
      <el-form-item label="适用学段：">
        <span>{{formInline.periodTypeName || ''}}</span>
      </el-form-item>
      <el-form-item label="应用描述语：">
        <span>{{formInline.appDescribe || '无'}}</span>
      </el-form-item>
      <el-form-item label="应用版本：" v-if="formInline.appStatus != 'app_status_4'">
        <span>{{formInline.appVersion || ''}}</span>
      </el-form-item>
      <el-form-item label="版本说明：" v-if="formInline.appStatus != 'app_status_4'">
        <span>{{formInline.appVersionExplain || '无'}}</span>
      </el-form-item>
      <el-form-item :label=visitUrlName v-if="formInline.appStatus != 'app_status_4'">
        <span class="blueFont finger" @click="open">{{formInline.visitUrl || ''}}</span>
      </el-form-item>
      <el-form-item label="测试报告：" v-if="formInline.appStatus != 'app_status_4'">
        <span class="blueFont finger" @click="down">{{formInline.testReportName || ''}}</span>
      </el-form-item>
      <el-form-item label="应用截屏：" v-if="formInline.appStatus != 'app_status_4' && formInline.appScreenshotArray">
        <el-image style="width: 115px; height: 115px" :src="formInline.appScreenshotArray[0]"
                  :preview-src-list="formInline.appScreenshotArray">
        </el-image>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import {
    PersonalPostAppInfoById,
  } from '@/views/index/api/personalCenter/api.personalCenter.js';
  import { autoDownloadUrl } from '@/utils/util.js';
  export default {
    data() {
      return {
        visitUrlName:"下载地址：",
        appId: null,
        formInline: {}
      }
    },
    mounted() {
      this.appId = this.$route.query.appId;
      this.getDevelopConfigData();
    },
    methods: {
      // 访问地址
      open() {
        window.open(this.formInline.visitUrl);
      },
      // 下载文档
      down() {
        autoDownloadUrl(this.formInline.testReport);
      },
      // 获取数据
      getDevelopConfigData() {
        this.visitUrlName="下载地址：";
        PersonalPostAppInfoById({ appId: this.appId }).then(res => {
          if (res && res.result) {
            this.formInline = res.result;
            if(res.result.appTerminalType == "app_terminal_type_1" || res.result.appTerminalType == "app_terminal_type_2" 
            || res.result.appTerminalType == "app_terminal_type_8"){
            this.visitUrlName="访问路径：";
          }
          }
        })
      }
    },
  }
</script>
<style lang="scss">
  .vl-person-detail {
    .el-form-item__label {
      color: #666 !important;
    }
    .el-form-item {
      margin-bottom: 18px !important;
    }
  }
  .finger {
      cursor: pointer;
  }

  .blueFont {
      color:#4286F5;
  }
</style>